import { render, staticRenderFns } from "./viaadmision.vue?vue&type=template&id=034803d0&scoped=true"
import script from "./viaadmision.vue?vue&type=script&lang=js"
export * from "./viaadmision.vue?vue&type=script&lang=js"
import style0 from "./viaadmision.vue?vue&type=style&index=0&id=034803d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034803d0",
  null
  
)

export default component.exports